<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <span class="zoneHeader__title">筛选条件</span>
            <div v-if="activeFilterCount" class="filterChips">
              <span class="filterChip">已筛选 {{ activeFilterCount }} 项</span>
              <button
                type="button"
                class="filterChip filterChip--clear"
                @click="$emit('reset-and-search')"
              >
                清除
              </button>
            </div>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonOutline"
              size="small"
              icon="el-icon-plus"
              v-check-role
              @click="$emit('go-create')"
            >
              新增解锁方式
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset-filters')"
            >
              重置
            </el-button>
          </div>
        </div>
        <div class="filterGrid">
          <div class="filterItem">
            <span class="searchText">方式名称</span>
            <el-input
              class="filterControl"
              placeholder="请输入解锁方式名称"
              prefix-icon="el-icon-search"
              :value="name"
              size="small"
              clearable
              @input="$emit('update:name', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">解锁方式</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="lockType"
              placeholder="全部方式"
              size="small"
              clearable
              filterable
              @change="$emit('update:lockType', $event)"
            >
              <el-option
                v-for="item in lockTypeOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPanelSummary" class="filterPanelSummary">
      <span class="filterPanelSummary__label">共</span>
      <strong class="filterPanelSummary__count">{{ panelTotalCount }}</strong>
      <span class="filterPanelSummary__label">条</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnlockModeListFilterPanel',
  props: {
    name: { type: String, default: '' },
    lockType: { type: String, default: '' },
    activeFilterCount: { type: Number, default: 0 },
    lockTypeOptions: { type: Array, default: () => [] },
    panelTotalCount: { type: Number, default: 0 },
    showPanelSummary: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';

.linkListFilterPanel {
  padding: 0;
  background: transparent;
}

.filterPanelSummary {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--link-line, #eee9e2);
}

.filterPanelSummary__label {
  font-size: var(--link-text-sm);
  color: var(--link-ink-secondary);
}

.filterPanelSummary__count {
  font-size: var(--link-text-lg);
  font-weight: var(--link-font-semibold);
  color: var(--link-accent);
  font-variant-numeric: tabular-nums;
}

.filterGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 10px;
}

.filterItem {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  align-items: center;
  column-gap: 8px;
}

.searchText {
  font-family: var(--link-font-family);
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
  text-align: right;
  white-space: nowrap;
}

.filterControl {
  width: 100%;
  max-width: 100%;
}

.filterDeckHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.filterDeckHeader__leading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.actionBar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

@media (max-width: 900px) {
  .filterGrid {
    grid-template-columns: 1fr;
  }

  .filterDeckHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .actionBar {
    justify-content: flex-start;
  }
}
</style>
